export default __webpack_public_path__ + "static/media/cfx-0.d92bf406.png";